/**
 * Global loader (dismissised on route complete event)
 */
import React from 'react';
import { connect } from 'react-redux';
import { GlobalLoaderType } from 'store/reducers/global-loader.reducer';

import Loader from '../Loader/Loader';

type Props = {
  showGlobalLoader: boolean;
  globalLoaderType: GlobalLoaderType;
};

const mapStateToProps = ({ globalLoaderData }) => ({
  showGlobalLoader: globalLoaderData?.showGlobalLoader,
  globalLoaderType: globalLoaderData?.globalLoaderType,
});

const GlobalLoader = (props: Props) => {
  const { showGlobalLoader, globalLoaderType } = props;

  return (
    <div className={`global-loader ${showGlobalLoader ? `global-loader--visible global-loader--${globalLoaderType}` : ''}`}>
      <Loader size={50} className="global-loader-spinner" />
    </div>
  );
};

export default connect(mapStateToProps)(GlobalLoader);
